import React from 'react';
import {useAppVersion} from "v4/contexts/AppVersionContext";
import OutdatedFrontPage from "v4/pages/front/OutdatedFront/OutdatedFrontPage";

export default function OutdatedFrontChecker({children}) {
    const {blocked} = useAppVersion();

    return blocked ? <OutdatedFrontPage/> : children
}
